<div class="page-content">
    <div class="container-fluid">
        <section>
            <div class="row ifa-campaign-banner">
                <div class="col-lg-7 col-xs-10" id="ifa-campaign-banner-text-section">
                    <h2 class="ifa-campaign-banner-text-heading">PARTNER WITH FINZY <br><span
                            class="pt-10">AND GROW</span></h2>
                    <ul class="ifa-campaign-banner-text">
                        <li>Long term commission structure for partners</li>
                        <li>Monthly payouts</li>
                        <li>In built partner referral model</li>
                        <li>Powerful rewards & recognition program</li>
                    </ul>
                    <button id="register-with-us-white-button" (click)="redirectToIfaHomePage()">Register with us</button>
                </div>
                <div class="col-lg-3 ifa-campaign-banner-form-section">
                    <h3 id="ifa-campaign-banner-form-section-heading">Get in touch</h3>
                    <h5 class="ifa-campaign-banner-form-section-subheading">Want to know more about how finzy works?
                        Please
                        provide your contact information & we will get in touch with you.</h5>
                    <app-enquire-now-form [profileType]=ProfileType.IFA></app-enquire-now-form>
                    <p class="call-us-enquire-section text-color-grey text-uppercase text-center">Or Call us : <span
                            class="text-color-finzy-blue display-inline-block">9341 800 800</span></p>
                </div>
            </div>
        </section>
        <section id="register-with-rbi" class="row grey-section">
            <div id="nbfc-registered">
                <h2 class="nbfc-registered-heading col-xs-offset-1 col-xs-10">finzy is an <b>NBFC - P2P</b> registered
                    with the <b>Reserve
                        Bank of
                        India(RBI).</b></h2>
                <p class="subheading col-xs-offset-1 col-xs-10">finzy is India's premier peer to peer lending portal. We
                    digitally connect investors to hand-picked borrowers to provide risk optimised returns that are as
                    high as 2.5 times of bank Fixed Deposit on an average.</p>
            </div>
        </section>
        <section class="advantage-section">
            <div class="row">
                <h2 class="heading col-xs-10 col-xs-offset-1">The finzy advantage for your clients</h2>
            </div>
            <div class="row">
                <p class="subheading col-xs-10 col-xs-offset-1 col-md-8 col-md-offset-2">
                    Easy investments. High returns.
                </p>
            </div>
            <div class="row">
                <div class="col-lg-10 col-lg-offset-1 col-xs-10 col-xs-offset-1">
                    <div class="row">
                        <div class="col-xs-12 col-sm-6 col-lg-3 card">
                            <div class="row card-image">
                                <div class="col-xs-12">
                                    <img src="../../../assets/images/finzy-for-a-financial-adviser/commission.svg"
                                         alt="commission"/>
                                </div>
                            </div>
                            <div class="row card-text">
                                <div class="col-xs-12">
                                    <h4 class="advantage-section-heading">Fills vacuum in
                                        current market offerings</h4>
                                    <p class="advantage-section-text">With 15.5% p.a. compounded returns on average,
                                        finzy helps fill the gap between high
                                        risk equity investments and low return debt investments</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-lg-3 card">
                            <div class="row card-image">
                                <div class="col-xs-12">
                                    <img src="../../../assets/images/finzy-for-a-financial-adviser/rewards.svg"
                                         alt="rewards"/>
                                </div>
                            </div>
                            <div class="row card-text">
                                <div class="col-xs-12">
                                    <h4 class="advantage-section-heading">Regular monthly<br/>
                                        returns</h4>
                                    <p class="advantage-section-text">finzy provides regular monthly returns. Investors
                                        can now start earning EMIs instead
                                        of only paying them. </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-lg-3 card">
                            <div class="row card-image">
                                <div class="col-xs-12">
                                    <img src="../../../assets/images/finzy-for-a-financial-adviser/referral.svg"
                                         alt="referral"/>
                                </div>
                            </div>
                            <div class="row card-text">
                                <div class="col-xs-12">
                                    <h4 class="advantage-section-heading">Diversified <br/>investments</h4>
                                    <p class="advantage-section-text">finzy enforces diversification of investments
                                        across multiple loans thereby
                                        optimising risks and returns. </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-lg-3 card">
                            <div class="row card-image">
                                <div class="col-xs-12">
                                    <img src="../../../assets/images/finzy-for-a-financial-adviser/monthly-payouts.svg"
                                         alt="monthly-payouts"/>
                                </div>
                            </div>
                            <div class="row card-text">
                                <div class="col-xs-12">
                                    <h4 class="advantage-section-heading">Access to a Retail <br/>asset class</h4>
                                    <p class="advantage-section-text">Individual investors now have access to retail
                                        loans and can explore a new asset
                                        class that isn’t linked to the markets.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="row takes-care-section grey-section">
            <div class="row">
                <h2 class="takes-care-section-heading col-xs-10 col-xs-offset-1">finzy takes care of your clients’ investments</h2>
            </div>
            <div class="row">
                <p class="subheading col-xs-10 col-xs-offset-1 col-md-8 col-md-offset-2">
                    finzy is a loan lifecycle management platform that focusses on all aspects of the loan from sourcing
                    to collections, thereby supporting you through the entire lifecycle of the loan.
                </p>
            </div>
            <div class="row">
                <div class="col-lg-10 col-lg-offset-1 col-xs-10 col-xs-offset-1">
                    <div class="row">
                        <div class="col-xs-12 col-sm-6 col-lg-3 take-care-card text-center">
                            <div class="row card-image transparent-background">
                                <div class="col-xs-12">
                                    <img src="../../../assets/images/finzy-for-a-financial-adviser/rupee-hand.svg"
                                         alt="commission"/>
                                </div>
                            </div>
                            <div class="row card-text transparent-background">
                                <div class="col-xs-12">
                                    <h4 class="advantage-section-heading">Hand Picked Borrowers</h4>
                                    <p class="advantage-section-text">Our sourcing methods and proprietary credit
                                        algorithm takes into account as many as 130 parameters to get you access to
                                        prime borrowers.</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-lg-3 take-care-card text-center">
                            <div class="row card-image transparent-background">
                                <div class="col-xs-12">
                                    <img src="../../../assets/images/finzy-for-a-financial-adviser/doc-lock.svg"
                                         alt="rewards"/>
                                </div>
                            </div>
                            <div class="row card-text transparent-background">
                                <div class="col-xs-12">
                                    <h4 class="advantage-section-heading">Secure Documentation</h4>
                                    <p class="advantage-section-text">Finzy meets borrowers in person for execution of
                                        loan agreements, stamp paper, post-dated cheques and demand promissory note
                                        ensuring documentation is complete and legally bound</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-lg-3 take-care-card text-center">
                            <div class="row card-image transparent-background">
                                <div class="col-xs-12">
                                    <img src="../../../assets/images/finzy-for-a-financial-adviser/coin-hand.svg"
                                         alt="referral"/>
                                </div>
                            </div>
                            <div class="row card-text transparent-background">
                                <div class="col-xs-12">
                                    <h4 class="advantage-section-heading">Automated EMI Collection</h4>
                                    <p class="advantage-section-text">Finzy collects monthly EMI electronically from the
                                        borrowers themselves and transfers them to your registered bank account. All
                                        information of your investment is available on your finzy dashboard </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-lg-3 take-care-card text-center">
                            <div class="row card-image transparent-background">
                                <div class="col-xs-12">
                                    <img src="../../../assets/images/finzy-for-a-financial-adviser/reload-user.svg"
                                         alt="monthly-payouts"/>
                                </div>
                            </div>
                            <div class="row card-text transparent-background">
                                <div class="col-xs-12">
                                    <h4 class="advantage-section-heading">Follow up & Recovery</h4>
                                    <p class="advantage-section-text">Finzy has a detailed follow-up and recovery
                                        process. This comprises of our call-center, field visits by our internal
                                        collection team, tie-ups with bank recognised collection agencies and
                                        lawyers</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section id="section-why-finzy" class="advantage-section row">
            <div class="row">
                <h2 class="heading col-xs-10 col-xs-offset-1">finzy for financial advisors</h2>
            </div>

            <div class="row">
                <p class="subheading col-xs-10 col-xs-offset-1">An additional revenue stream for you and a powerful
                    asset for your clients. There are multiple benefits of partnering with us. </p>
            </div>

            <div class="row">
                <div class="col-xs-10 col-xs-offset-1 display-flex justify-center">
                    <div class="row">
                        <div class="col-md-6 col-xs-12 mx-0">
                            <div class="ifa-big-number-layout">
                                <span class="big-number text-color-faded-blue"> <img
                                        src="../../../assets/images/ifa-campaign/1-round.svg"
                                        alt="1"/></span>
                                <span class="big-number-label"><b>Multiply your revenues</b> and overcome the tightening regulatory environment on conventional financial product distribution</span>
                            </div>
                        </div>

                        <div class="col-md-6 col-xs-12 mx-0">
                            <div class="ifa-big-number-layout">
                                <span class="big-number text-color-faded-blue">
                                    <img src="../../../assets/images/ifa-campaign/2-round.svg"
                                         alt="2"/></span>
                                <span class="big-number-label">Balance your client's investment portfolio with an asset class that has <b>no correlation to market volatility/risk</b></span>
                            </div>
                        </div>

                        <div class="col-md-6 col-xs-12 mx-0">
                            <div class="ifa-big-number-layout">
                                <span class="big-number text-color-faded-blue"> <img
                                        src="../../../assets/images/ifa-campaign/3-round.svg"
                                        alt="3"/></span>
                                <span class="big-number-label">A <b>new regular return asset class</b> to your  client's portfolio</span>
                            </div>
                        </div>

                        <div class="col-md-6 col-xs-12 mx-0">
                            <div class="ifa-big-number-layout">
                                <span class="big-number text-color-faded-blue"> <img
                                        src="../../../assets/images/ifa-campaign/4-round.svg"
                                        alt="4"/></span>
                                <span class="big-number-label">Help your clients earn compounded returns with finzy’s ReinvestPro. Set preferences one time and <b>automatically reinvest returns</b></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-xs-12 text-center">
                    <button id="register-with-us-blue-button" (click)="redirectToIfaHomePage()">Register with us</button>
                </div>
            </div>
        </section>
        <section class="row adviser-section">
                <div class="col-lg-7 col-lg-offset-7 adviser-section-content">
                    <h2 class="adviser-section-heading">finzy support to onboard your clients</h2>
                        <p class="adviser-section-subheading">Partnering on presenting the asset class to your clients is an effective way of conveying the benefits of finzy to them. This will also help you on-board clients easily.</p>
                    <p class="adviser-section-list-title">We can help with this through: </p>
                    <ul class="adviser-section-text">
                        <li> <b>Joint meetings with your clients</b></li>
                        <li><b>Webinars or Conference Calls to explain the finzy advantage</b></li>
                        <li><b>Conduct Seminars for your clients</b></li>
                    </ul>
                </div>
        </section>
        <section id="section-client-testimonials" class="row advantage-section" #clientTestimonials>
            <div class="row">
                <h2 class="heading col-xs-10 col-xs-offset-1">What our customers say</h2>
            </div>

            <div class="row">
                <p class="subheading col-xs-10 col-xs-offset-1 col-md-8 col-md-offset-2">
                    Here is what investors who have experienced finzy have to say</p>
            </div>

            <div class="row">
                <div class="col-xs-12 col-md-10 col-md-offset-1">
                    <div id="testimonials-carousel" class="carousel slide" data-ride="carousel" data-interval="3000">

                        <div class="testimonial-cards carousel-inner grey-background-color">

                            <div class="row item active">
                                <div class="col-xs-12">
                                    <div class="row testimonial-card">
                                        <div class="col-xs-12">
                                            <img class="img-responsive img-circle testimonial-card-image"
                                                 alt="Girish Vyasamudri, an investor with finzy"
                                                 src="https://res.cloudinary.com/finzy/image/upload/v1539242301/testimonials/girish.jpg">
                                            <p class="name">Girish Vyasamudri</p>
                                            <p class="location">VP & Head of Operations at a Software Company,
                                                Bangalore</p>
                                            <p class="review">As someone who considers himself a seasoned investor, I
                                                have been very
                                                pleasantly surprised by the latest innovation on Finzy, namely
                                                Reinvest-Pro. The feature not
                                                only significantly reduces the risks and increases the returns, it also
                                                does so in a very
                                                seamless manner. The investor doesn't have to keep track of multiple
                                                things and can let the
                                                system work its magic, but still can change things any time he/she
                                                wishes. A great addition to
                                                the already attractive nature of the Finzy platform that every investor
                                                has to take benefit
                                                from.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row item">
                                <div class="col-xs-12">
                                    <div class="row testimonial-card">
                                        <div class="col-xs-12">
                                            <img class="img-responsive img-circle testimonial-card-image"
                                                 alt="Kuldeep Patnaik, an investor with finzy"
                                                 src="https://res.cloudinary.com/finzy/image/upload/v1539242315/testimonials/kuldeep-pattanaik.jpg">
                                            <p class="name">Kuldeep Patnaik</p>
                                            <p class="location">Manager - Toyota, Bangalore</p>
                                            <p class="review"> In this busy work life there isn't real scope
                                                to understand investment options , evaluate them , and invest. Moreover,
                                                the complications of
                                                ups and downs of market impacting my investment. Finzy is strongly
                                                recommended for people like
                                                me... I started investing 8 months back and I am thoroughly impressed
                                                with a consistent returns
                                                of ₹ 13k coming to my account as interest each month with a wonderful
                                                feature Reinvest-Pro. Now
                                                this is what I love the most - finzy takes care of my investment with my
                                                focus clearly on
                                                returns and without need to understand the financial complexities.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row item">
                                <div class="col-xs-12">
                                    <div class="row testimonial-card">
                                        <div class="col-xs-12">
                                            <img class="img-responsive img-circle testimonial-card-image"
                                                 alt="Urmila Ramgharia, an investor with finzy"
                                                 src="https://res.cloudinary.com/finzy/image/upload/v1539759781/testimonials/urmila_gz55an.jpg">
                                            <p class="name">Urmila Ramgarhia</p>
                                            <p class="location">Home Maker, Kolkata</p>
                                            <p class="review">All my life , there was a sense of having
                                                money but traditionally kept in fixed deposit with money at bank and
                                                returns very less, till I
                                                was introduced to finzy. Now all my FD has been moved to finzy and I get
                                                almost 2.5 times FD
                                                interest coming to me every month, that's smart - it helps me take care
                                                of my monthly expenses
                                                without depending on anybody + my investment is getting reinvested.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <ol class="carousel-indicators">
                            <li data-target="#testimonials-carousel" data-slide-to="0" class="active"></li>
                            <li data-target="#testimonials-carousel" data-slide-to="1"></li>
                            <li data-target="#testimonials-carousel" data-slide-to="2"></li>
                        </ol>

                    </div>
                </div>
            </div>
        </section>
        <section id="bacome-an-ifa" class="row blue-section">
            <div class="row">
                <h2 class="heading text-white col-xs-10 col-xs-offset-1">Become a channel partner for sourcing
                    loans</h2>
            </div>
            <div class="row">
                <p class="subheading text-white col-xs-10 col-xs-offset-1 col-md-8 col-md-offset-2">
                    We are also happy to partner with you to help source the right borrowers
                </p>
            </div>
            <div class="row">
                <div class="col-xs-12 col-md-7">
                    <div class="left-blue-sub-section">
                        <div class="sub-section-header">finzy for borrowers</div>
                        <div class="sub-section-list">
                            <p>- Quick and Hassle-free loans</p>
                            <p>- No prepayment charges, no lock-in periods</p>
                            <p>- Interest rates start at 7.99% p.a.</p>
                        </div>
                        <div class="sub-section-footer">Attractive commission structure for our channel partners</div>
                    </div>
                </div>
                <div class="col-xs-12 col-md-5">
                    <div class="right-blue-sub-section">
                        <div class="right-blue-sub-section-header">finzy is happy to help!</div>
                        <div class="right-blue-sub-section-body">
                            <p>Call us : 9341 800 800</p>
                            <p>Email us : partners@finzy.com</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <app-partner-with-us-for-benefits [sectionColor]='grey'></app-partner-with-us-for-benefits>
        <app-logo-only-header></app-logo-only-header>
        <app-core-team-section></app-core-team-section>
        <app-we-have-been-in-the-news [sectionColor]='grey'></app-we-have-been-in-the-news>
        <app-awards-and-accreditations class="white-section"></app-awards-and-accreditations>
        <app-campaign-enquire-footer [profileType]="ProfileType.IFA"></app-campaign-enquire-footer>
    </div>
</div>
